module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col page-element"
  }, [_c('b-modal', {
    ref: "uploadFileModal",
    attrs: {
      "hide-footer": "",
      "title": "Dodaj plik"
    }
  }, [(_vm.uploadForm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), _c('upload-file', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadForm.loading == false),
      expression: "uploadForm.loading == false"
    }],
    ref: "addFileForm",
    attrs: {
      "post-action": _vm.uploadFileUrl
    },
    on: {
      "loading": function($event) {
        _vm.uploadForm.loading = $event
      },
      "success": function($event) {
        return _vm.hideModal()
      }
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', [_c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadForm.loading == false),
      expression: "uploadForm.loading == false"
    }],
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_c('span', [_vm._v("Anuluj")]), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadForm.loading == false),
      expression: "uploadForm.loading == false"
    }],
    staticClass: "mt-3",
    attrs: {
      "variant": "default",
      "block": ""
    },
    on: {
      "click": _vm.sendFileForm
    }
  }, [_c('span', [_vm._v("Zapisz")]), _c('svg-icon', {
    attrs: {
      "name": "tick"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('page-title', [_c('h3', [_vm._v("Lista dokumentów")]), _vm._v(" "), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('b-button', {
    attrs: {
      "variant": "default"
    },
    on: {
      "click": _vm.showModal
    }
  }, [_c('span', [_vm._v("Dodaj skan dokumentu")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.itemsWithType), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item['originalName']))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item['name']))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item['type']))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-icon",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.downloadFile(item.id)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "download"
      }
    })], 1)])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nazwa pliku")]), _vm._v(" "), _c('th', [_vm._v("Opis")]), _vm._v(" "), _c('th', [_vm._v("Typ")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19dcef58","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/customer/DocumentList.vue
// module id = 785
// module chunks = 0